export function isAllUpperCaseLetters(str: string): boolean | undefined {
  return !str ? undefined : /^[A-Z]+$/.test(str)
}
